import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route changes jump instantly. With the global `scroll-behavior: smooth`, the new page used to
// glide up from the previous page's scroll position, sweeping through every scroll reveal on the way.
export function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const root = document.documentElement;
    const jump = (fn: () => void) => {
      const prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      fn();
      root.style.scrollBehavior = prev;
    };
    if (hash) {
      const id = hash.slice(1);
      const frame = window.requestAnimationFrame(() => {
        jump(() => document.getElementById(id)?.scrollIntoView({
          block: 'start'
        }));
      });
      return () => window.cancelAnimationFrame(frame);
    }
    jump(() => window.scrollTo(0, 0));
    return undefined;
  }, [pathname, hash]);
  return null;
}